import { useCallback, useEffect, useState } from 'react'

import { User } from '@lib/services/user/user'

import { useUserService } from './index'

interface CurrentUser {
  isLoading: boolean
  user: User
}

export const useGetCurrentUser = (): CurrentUser => {
  const userService = useUserService()

  const [userState, setUserState] = useState({
    user: userService.currentUser,
    isLoading: userService.currentUser.isNone,
  })

  const loadUser = useCallback(async () => {
    let user = userService.currentUser

    try {
      user = await userService.initialLoad()
    } catch {
      user = User.None
    } finally {
      setUserState({ isLoading: false, user })
    }
  }, [userService])

  useEffect(() => {
    // If user has been set by web-server, then there is no need to load the user
    if (userService.currentUser.isNone) {
      void loadUser()
    }
  }, [loadUser, userService.currentUser.isNone])

  return userState
}
